import { createSelector } from 'reselect';

const selectIntl = ({ intl }) => intl;

const selectSystemLocale = createSelector(selectIntl, ({ locale }) => locale);

export default {
  selectSystemLocale,
};
